module.exports = __webpack_public_path__ + "img/member_rights_icon_431003.400f82a9.jpg";